// import React from 'react';
// import Checkbox from '@mui/material/Checkbox';
// import Radio from '@mui/material/Radio';
// import { grey } from '@mui/material/colors';
// import { styled } from '@mui/material/styles';

// //checkbox component material ui normal
// var styles = {
//     root: {
//       color: grey[900],
//       '&$checked': {
//         color: '#00B0A9',
//       },
//       padding: '0px'
//     },
//     checked: {},
//   };


// class CheckboxMaterialUI extends React.Component {
//     state = { 
//         checkboxStatus: this.props.checkedStatus || false,   
//   };

//   handleChange = name => event => {
//       this.setState({ [name]: event.target.checked });
//       this.props.changeHandler(event.target.checked)
//   };

//   render() {
//     const { classes } = this.props;    
//     return ( 
//         <Checkbox
//           checked={this.props.checkedStatus}
//           onChange={this.handleChange('checkboxStatus')}
//           value="checkboxStatus"
//           classes={{
//             root: classes.root,
//             checked: classes.checked,
//           }}
//           />        
//     );
//   }
// }

// export default styled(styles)(CheckboxMaterialUI);


import React from 'react';
import Checkbox from '@mui/material/Checkbox';
import { grey } from '@mui/material/colors';
import { withStyles } from '@mui/styles';

const styles = {
  root: {
    color: grey[900],
    '&$checked': {
      color: '#00B0A9',
    },
    padding: '0px',
  },
  checked: {},
};

class CheckboxMaterialUI extends React.Component {
  state = {
    checkboxStatus: this.props.checkedStatus || false,
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
    this.props.changeHandler(event.target.checked);
  };

  render() {
    const { classes } = this.props;
    return (
      // <Checkbox
      //   checked={this.props.checkedStatus}
      //   onChange={this.handleChange('checkboxStatus')}
      //   value="checkboxStatus"
      //   classes={{
      //     root: classes.root,
      //     checked: classes.checked,
      //   }}
      // />
         <input type='checkbox' onChange={this.handleChange('checkboxStatus')} checked={this.props.checkedStatus}/>
    );
  }
}

export default withStyles(styles)(CheckboxMaterialUI);
